import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VTextField,
    _vm._b(
      {
        directives: [
          {
            name: "mask",
            rawName: "v-mask",
            value: _setup.maskTemplate,
            expression: "maskTemplate",
          },
        ],
        attrs: {
          value: _vm.value,
          autofocus: _vm.autofocus,
          "persistent-placeholder": "",
          "clear-icon": "ui-icon-close-not-a-circle",
          "hide-details": "",
          clearable: "",
          outlined: "",
          type: "tel",
          inputmode: "numeric",
        },
        on: {
          focus: _setup.handleFocus,
          blur: _setup.handleBlur,
          "click:clear": function ($event) {
            return _vm.$emit("input", undefined)
          },
        },
        nativeOn: {
          input: function ($event) {
            return _setup.emitInput.apply(null, arguments)
          },
        },
      },
      "v-text-field",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }